import { render, staticRenderFns } from "./ModalListaGrupoAvaliacao.vue?vue&type=template&id=5a139400"
import script from "./ModalListaGrupoAvaliacao.vue?vue&type=script&lang=js"
export * from "./ModalListaGrupoAvaliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports